import React from "react";
// import bg from "../asset/Health _Two Color.png";
import Jumbotron from "react-bootstrap/Jumbotron";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
// import bgimage from "../asset/bg.jpg";
// import bgimage from "../asset/Health _Two Color.png";
import bgimage from "../asset/im.jpg";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
joinpimg: {
display: "flex",
},

bgimg: {
height: 250,
width: 250,
},
buttons: {
textDecoration: "none",
color: "white",
},
}));

const UserManualComponent = () => {
const classes = useStyles();
return (
<Jumbotron>
<h1 className={classes.h1s}>User Manual</h1>
<br />
{/* <div className={classes.joinpimg}> */}
<img src={bgimage} alt="sidebgimg" className={classes.bgimg} />
<br />
<br />
<h4>
This is the user manual for all the users. Do give this a read and get
proper information about the procedure and all the rules to be followed.
</h4>
<h4 className="para">
To read the user manual click on the link given below.
</h4>

{/* </div> */}
<p>
<Button variant="primary" className={classes.buttons}>
<a
className={classes.buttons}
href="https://drive.google.com/file/d/16haKMXb-4acQi5n6iGUl8bM3-UJLauNj/view?usp=sharing ">
Download
</a>
</Button>
</p>
</Jumbotron>
);
};

export default UserManualComponent;
